export const CAROUSEL_MODULE_TEST_ID = {
  pageCarousel: 'page-carousel',
};

export const CAROUSEL_EVENT_DELAY = 300;
